"use strict";
/**
 * Created by Ning Jiang on 2/7/2018.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullScreenClicker = void 0;
const NolimitApplication_1 = require("@nolimitcity/slot-launcher/bin/NolimitApplication");
const BaseView_1 = require("../base/BaseView");
const StageManager_1 = require("../stage/StageManager");
class FullScreenClicker extends BaseView_1.BaseView {
    get enabled() {
        return this._enabled;
    }
    set enabled(value) {
        if (value === this._enabled) {
            return;
        }
        this._enabled = value;
        if (this._clicker) {
            this._clicker.interactive = this._enabled;
            this._clicker.buttonMode = this._enabled;
        }
        if (this._enabled) {
            if (this._isResizeDirty) {
                this.onResize(this._resizeData);
            }
            if (this._clickerContainer.children.indexOf(this._clicker) === -1) {
                this._clickerContainer.addChild(this._clicker);
            }
        }
        else if (this._clickerContainer.children.indexOf(this._clicker) > -1) {
            this._clickerContainer.removeChild(this._clicker);
        }
    }
    constructor(onClickCallback, layer, resourcesGroup) {
        super(resourcesGroup);
        this._enabled = false;
        this._onClickCallback = onClickCallback;
        this._layer = StageManager_1.StageManager.getLayer(layer);
    }
    initAnimations() {
        this._clickerContainer = new PIXI.Container();
        this._layer.addChild(this._clickerContainer);
        this._clicker = new PIXI.Graphics();
        this._clicker.on('pointertap', (e) => this._onClickCallback(e));
    }
    onResize(resizeData) {
        if (StageManager_1.StageManager.legacyScaling) {
            this._screenWidth = Math.ceil(resizeData.width / this._layer.scale.x);
            this._screenHeight = Math.ceil(resizeData.height / this._layer.scale.y);
            this._leftOffset = Math.floor(-this._layer.x / this._layer.scale.x);
            this._topOffset = Math.floor(-this._layer.y / this._layer.scale.y);
        }
        else {
            this._screenWidth = NolimitApplication_1.NolimitApplication.screenBounds.width;
            this._screenHeight = NolimitApplication_1.NolimitApplication.screenBounds.height;
            this._leftOffset = NolimitApplication_1.NolimitApplication.screenBounds.left;
            this._topOffset = NolimitApplication_1.NolimitApplication.screenBounds.top;
        }
        if (!this._enabled) {
            this._isResizeDirty = true;
            return;
        }
        this._clicker.clear();
        this._clicker.beginFill(0xFF0000, 1);
        this._clicker.alpha = 0;
        this._clicker.drawRect(this._leftOffset, this._topOffset, this._screenWidth, this._screenHeight);
        this._isResizeDirty = false;
    }
}
exports.FullScreenClicker = FullScreenClicker;
//# sourceMappingURL=FullScreenClicker.js.map